export const Posts = [
  {
    id: 1,
    title: "ballon D'or Winnners 2021",
    slug: "ballon-d'or-winnners-2021",
    image:
      "https://images2.minutemediacdn.com/image/upload/c_crop,w_5001,h_2813,x_0,y_295/c_fill,w_720,ar_16:9,f_auto,q_auto,g_auto/images/GettyImages/mmsport/90min_en_international_web/01fnp5yts7qawy3c9ad4.jpg",
    authors: [1],
    isFeatured: false,
    visibility: "public",
    tags: [1, 6],
    published_at: "2022-11-26",
    reading_time: 10,
    body:postBody(),
  },
  {
    id: 2,
    title: "Whats new in Laravel 9",
    slug: "whats-new-in-laravel-9",
    image:
      "https://c4.wallpaperflare.com/wallpaper/801/330/425/laravel-php-code-simple-wallpaper-preview.jpg",
    authors: [2, 3],
    isFeatured: true,
    visibility: "public",
    tags: [2, 5],
    published_at: "2022-01-26",
    reading_time: 20,
    body:postBody(),
  },
  {
    id: 3,
    title: "Billboard top 100 songs",
    slug: "billboard-top-100-songs",
    image: "https://i.scdn.co/image/ab67706c0000bebb3bd5501a335b265807df34db",
    authors: [3,5],
    isFeatured: false,
    visibility: "private",
    tags: [3, 7],
    published_at: "2022-02-26",
    reading_time: 8,
    body:postBody(),
  },
  {
    id: 4,
    title: "Spiderman No Way Home Review",
    slug: "spiderman-no-way-home-review",
    image:
      "https://c4.wallpaperflare.com/wallpaper/763/710/546/spiderman-no-way-home-spiderverse-superhero-movies-digital-hd-wallpaper-preview.jpg",
    authors: [4,5],
    isFeatured: true,
    visibility: "public",
    tags: [4],
    published_at: "2022-03-26",
    reading_time: 30,
    body:postBody(),
  },
  {
    id: 5,
    title: "Uefa fixtures 2022",
    slug: "uefa-fixtures-2022",
    image:
      "https://c4.wallpaperflare.com/wallpaper/426/395/739/champions-league-uefa-soccer-wallpaper-preview.jpg",
    authors: [1, 2],
    isFeatured: false,
    visibility: "public",
    tags: [1, 6],
    published_at: "2022-04-26",
    description:
      "Quid ad utilitatem tantae pecuniae. Duo enim genera quae erant, fecit tria. Et quod est munus, quod opus sapientiae.",
    reading_time: 8,
    body:postBody(),
  },
  {
    id: 6,
    title: "Svelte Upcoming Best JS Framework",
    slug: "svelte-upcoming-best-js-framework",
    image:
      "https://valuelogic.one/blog/wp-content/uploads/2020/11/Svelte-blogpost.png",
    authors: [2,5],
    isFeatured: false,
    visibility: "public",
    tags: [2],
    published_at: "2022-05-26",
    description:
      "Quid ad utilitatem tantae pecuniae. Duo enim genera quae erant, fecit tria. Et quod est munus, quod opus sapientiae.",
    reading_time: 19,
    body:postBody(),
  },
  {
    id: 7,
    title: "BTS sold out Wembley",
    slug: "BTS-sold-out-wembley",
    image: "https://korebu.com/wp-content/uploads/2020/10/bts-variety.jpg",
    authors: [3, 1],
    isFeatured: false,
    visibility: "public",
    tags: [3, 7],
    published_at: "2022-06-26",
    description:
      "Quid ad utilitatem tantae pecuniae. Duo enim genera quae erant, fecit tria. Et quod est munus, quod opus sapientiae.",
    reading_time: 7,
    body:postBody(),
  },
  {
    id: 8,
    title: "Top 10 Netflix series to watch 2022",
    slug: "top-10-netflix-series-to-watch-2022",
    image:
      "https://www.notebookcheck.net/fileadmin/Notebooks/News/_nc3/A9DF1171_458C_4D7B_A253_573AF2ED7CB6.png",
    authors: [4, 3],
    isFeatured: false,
    visibility: "public",
    tags: [4],
    published_at: "2022-07-16",
    description:
      "Quid ad utilitatem tantae pecuniae. Duo enim genera quae erant, fecit tria. Et quod est munus, quod opus sapientiae.",
    reading_time: 4,
    body:postBody(),
  },
  {
    id: 9,
    title: "Should EPL be Postponed?",
    slug: "should-EPL-be-postponed",
    image:
      "https://assets.turbologo.com/blog/en/2020/01/19084653/Premier-League-symbol.png",
    authors: [1,6],
    isFeatured: false,
    visibility: "private",
    tags: [1, 6],
    published_at: "2022-01-12",
    description:
      "Quid ad utilitatem tantae pecuniae. Duo enim genera quae erant, fecit tria. Et quod est munus, quod opus sapientiae.",
    reading_time: 17,
    body:postBody(),
  },
  {
    id: 10,
    title: "Why you should learn Ruby 2022",
    slug: "why-you-should-learn-ruby-2022",
    image:
      "https://www.pngitem.com/pimgs/m/12-120179_best-free-ruby-png-ruby-programming-language-logo.png",
    authors: [2,7],
    isFeatured: false,
    visibility: "public",
    tags: [2],
    published_at: "2022-04-11",
    description:
      "Quid ad utilitatem tantae pecuniae. Duo enim genera quae erant, fecit tria. Et quod est munus, quod opus sapientiae.",
    reading_time: 12,
    body:postBody(),
  },
  {
    id: 11,
    title: "BET Awards 2022 results",
    slug: "BET-awards-2022-results",
    image:
      "https://media.gettyimages.com/photos/award-on-display-in-the-press-room-at-the-2012-bet-awards-at-the-on-picture-id147545448",
    authors: [3,8],
    isFeatured: false,
    visibility: "public",
    tags: [3],
    published_at: "2022-12-26",
    description:
      "Quid ad utilitatem tantae pecuniae. Duo enim genera quae erant, fecit tria. Et quod est munus, quod opus sapientiae.",
    reading_time: 15,
    body:postBody(),
  },
  {
    id: 12,
    title: "Dune 2 Review",
    slug: "dune-2-review",
    image:
      "https://i.pinimg.com/originals/ca/5b/91/ca5b9160371f176a522a110136e2dcc1.jpg",
    authors: [4,7],
    isFeatured: false,
    visibility: "public",
    tags: [4],
    published_at: "2023-12-31",
    description:
      "Quid ad utilitatem tantae pecuniae. Duo enim genera quae erant, fecit tria. Et quod est munus, quod opus sapientiae.",
    reading_time: 30,
    body:postBody(),
  },
  {
    id: 13,
    title: "Can Xavi Revive Barcelona?",
    slug: "can-xavi-revive-barcelona",
    image:
      "https://c4.wallpaperflare.com/wallpaper/837/385/136/barcelona-fc-barcelona-stadium-camp-nou-wallpaper-preview.jpg",
    authors: [1, 4,6],
    isFeatured: true,
    visibility: "public",
    tags: [1],
    published_at: "2022-03-19",
    description:
      "Quid ad utilitatem tantae pecuniae. Duo enim genera quae erant, fecit tria. Et quod est munus, quod opus sapientiae.",
    reading_time: 12,
    body:postBody(),
  },
  {
    id: 14,
    title: "JS Array methods every developer must know",
    slug: "js-array-methods-every-developer-must-know",
    image:
      "https://c4.wallpaperflare.com/wallpaper/562/372/1012/programmers-javascript-minimalism-wallpaper-preview.jpg",
    authors: [2, 3,8],
    isFeatured: false,
    visibility: "public",
    tags: [2,5],
    published_at: "2022-08-12",
    description:
      "Quid ad utilitatem tantae pecuniae. Duo enim genera quae erant, fecit tria. Et quod est munus, quod opus sapientiae.",
    reading_time: 25,
    body:postBody(),
  },
  {
    id: 15,
    title: "Ten songs you must listen on Spotify 2022",
    slug: "ten-songs-you-must-listen-on-spotify-2022",
    image:
      "https://c4.wallpaperflare.com/wallpaper/418/665/208/music-green-minimalism-logo-wallpaper-preview.jpg",
    authors: [3],
    isFeatured: false,
    visibility: "public",
    tags: [3],
    published_at: "2022-09-10",
    reading_time: 12,
    body:postBody(),
  },
  {
    id: 16,
    title: "Who should be the next James Bond?",
    slug: "who-should-be-the-next-james-bond",
    image:
      "https://c4.wallpaperflare.com/wallpaper/566/384/903/james-bond-skyfall-film-stills-movies-wallpaper-preview.jpg",
    authors: [4],
    isFeatured: true,
    visibility: "private",
    tags:[4, 7],
    published_at: "2022-01-31",
    reading_time: 14,
    body:postBody(),
  },
];

function postBody(){
     return `Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi, consectetur? Dignissimos illo corporis sed at
     incidunt inventore libero. Optio alias repellat doloremque quos quia commodi libero molestiae! Repellat commodi
     laboriosam fuga aliquam officia officiis, nisi temporibus blanditiis iste suscipit accusantium rerum sunt
     explicabo, atque eveniet laudantium voluptatum voluptatem error, necessitatibus dolores possimus ex in eaque
     itaque! Totam maiores asperiores non quod tenetur est quaerat quia commodi adipisci repudiandae molestias
     perferendis provident quos possimus quibusdam consequuntur dolore placeat quam a facere, ducimus aspernatur ad?
     Aperiam consectetur deserunt doloremque quaerat voluptates voluptate cupiditate eum eveniet magni aspernatur
     dolorum in quidem a, repellendus ullam provident consequuntur sapiente possimus repudiandae ad perspiciatis
     necessitatibus molestias. Ex ab reprehenderit debitis obcaecati expedita dolorum ea quibusdam dicta vitae magnam
     asperiores provident rem eius ut alias corrupti laudantium ipsa officia quo sed quam ad, et molestiae. Corporis
     reprehenderit sed dolores enim esse voluptate. Amet, quam modi quasi maiores a animi blanditiis repellendus
     accusantium ab illo beatae inventore laborum? Nostrum officia minus perspiciatis numquam beatae cupiditate, iure
     ipsum ducimus voluptatem non soluta quod, dolor nobis eveniet reiciendis error tempora iste culpa inventore at
     minima. Rem quaerat itaque, excepturi dolores dolor velit deserunt recusandae perspiciatis consequatur eos,
     repellendus, minus illum labore ea sed ipsam blanditiis possimus consequuntur enim magni! Iusto incidunt ipsum
     facere corrupti laboriosam harum asperiores, nobis blanditiis? Architecto incidunt excepturi magnam sequi
     provident? Porro pariatur nulla odit ea at natus ipsam sequi a ab fuga dicta non ad illum voluptate provident,
     tempore itaque quis aspernatur tempora dignissimos accusantium. Eos voluptate hic adipisci, laudantium nihil,
     laboriosam odit sapiente ipsa dolorum porro saepe aperiam doloribus pariatur eum quidem earum ad libero cupiditate
     architecto! Magnam consequuntur repudiandae quasi in error quo quibusdam officiis provident incidunt et,
     recusandae aut omnis explicabo soluta eum dolores, nulla, consectetur nemo? Facere mollitia impedit itaque non
     nulla ea veritatis nemo temporibus natus ducimus praesentium provident enim voluptatibus consequuntur quibusdam
     in, quos vero, ut, aut magni perspiciatis delectus corrupti? Sequi deleniti a ut minus dolor itaque amet voluptas
     ipsam sint corporis, architecto eos quos iusto, deserunt veniam esse vel laboriosam odio quaerat repellat hic
     ducimus doloribus illum enim! Dolore, similique modi eligendi aperiam ipsum, dicta quo id, quisquam perferendis
     obcaecati sit neque rem alias doloribus ullam optio deleniti earum accusantium minima ab voluptates. Repellat
     voluptas hic maxime distinctio, obcaecati incidunt ipsam, architecto dolorum excepturi dolores fugiat doloribus
     perspiciatis at, ipsum nemo perferendis similique enim fugit nulla facilis porro dolore non ut officiis!
     Consectetur architecto iste esse, cumque eius, enim magni vitae laudantium inventore earum nulla eligendi eum
     ipsa. Delectus distinctio harum animi, sapiente repudiandae quae consequatur corrupti asperiores excepturi in sint
     est repellat labore unde adipisci! Aliquam odit at, dolores ullam numquam minima delectus saepe ex dicta.
     Officiis, esse aliquid ullam necessitatibus placeat dolorum laboriosam quia commodi sunt blanditiis, minima nihil
     sequi deserunt cum ipsum libero eum aperiam sint dolores, dicta corporis iusto consequatur! Cumque consequatur
     quae quasi dolorum error deleniti excepturi dolores, inventore aliquam vitae cum quos atque soluta commodi? Culpa
     architecto quaerat dolorem animi ducimus natus inventore earum modi, sit, facilis, unde quidem illum maiores.
     Tempora facilis sed corporis iure! Maxime, ipsam vero. Odio nisi praesentium nam dolore, aperiam incidunt ex
     cupiditate officiis iure voluptate autem. Soluta, aliquam cum atque voluptates libero, incidunt commodi recusandae
     eius rem adipisci ducimus reiciendis id corporis modi provident. Atque reiciendis fuga quo. Delectus debitis ab
     saepe exercitationem distinctio culpa eligendi quidem atque! Dolorum voluptatem ut cum ullam rem, nisi beatae
     omnis obcaecati doloribus labore voluptatum autem illum eum, velit tempora non sequi molestiae amet iste
     reiciendis facilis cupiditate reprehenderit. Aut, natus similique eius laboriosam fugiat earum, excepturi eligendi
     possimus, ipsam harum quam voluptatibus saepe. Temporibus excepturi vel ad, magnam rerum vitae et sed qui non,
     repudiandae harum! Odit facere, enim neque quia nam consequuntur iure sunt autem repellendus earum perferendis
     laboriosam placeat ipsa vitae laborum qui exercitationem deleniti voluptatibus a suscipit assumenda magni! Soluta
     commodi illo eligendi. Reiciendis reprehenderit accusantium explicabo itaque omnis enim debitis nam, aperiam earum
     qui sed at pariatur dolorum velit repellat vitae. Quibusdam tempora tempore nihil repellat incidunt! Unde deleniti
     veritatis ad iusto quisquam consequatur cumque vero provident voluptatum, mollitia nisi ipsam perferendis laborum
     placeat laudantium autem praesentium odit fugiat animi soluta nulla quas eligendi ullam! Error, veritatis nostrum
     reiciendis quibusdam eveniet nobis deserunt! Recusandae temporibus doloremque a aspernatur autem et repellendus,
     optio omnis, cumque alias laudantium hic. Earum itaque hic sequi error aut repellat accusamus praesentium
     incidunt. Minus fugit incidunt, accusamus aperiam nobis rerum dolorum molestiae dignissimos eligendi eum tenetur
     in neque exercitationem corrupti eaque laudantium, fugiat reiciendis facilis possimus quas ipsa non voluptate!
     Quam eveniet eos facere ea consectetur commodi consequuntur officiis autem non tempore ipsa earum ut tempora at
   `
   
}